import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirPricing } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirPricingAdapter = createEntityAdapter<JSONApiDataObject<BsdirPricing>>({
  selectId: item => item.id
});

export const bsdirPricingSlice = createSlice({
  name: 'bsdirPricing',
  initialState: bsdirPricingAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirPricing>),
  reducers: {
    bsdirPricingAdded: (state, action) => {
      bsdirPricingAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirPricingSelectors = bsdirPricingAdapter.getSelectors(
  (state: RootState) => state.bsdir.pricing);
export default bsdirPricingSlice.reducer;
